import {getEssentialData} from "src/server/preloader/utils";
import * as Sentry from "@sentry/nextjs";
import {getAxiosInstance} from "src/server/utils/getAxiosInstance";
import {getDeals} from "src/server/preloader/deals";
import {PrefetchedDataKeys} from "src/server/constants";
import * as ProductsApi from "src/core/api/products";

const fetchDealsData = async ({shop, host, ...params}) => {
  let data;
  try {
    data = await getEssentialData(shop, host, params);
  } catch (e) {
    console.error("Error fetching essential data", e);
    Sentry.setTag("Essential data Prefetch Error", true);
    Sentry.captureException(e);
    return {};
  }

  try {
    console.log(`Fetching deals page data. Shop: ${shop}, Host: ${host}`);

    const axiosInstance = getAxiosInstance(shop, host);

    const {prerenderData} = data;

    const [dealsData, products] = await Promise.all([
      getDeals(axiosInstance),
      ProductsApi.list({offset: 0, on_sale: true}, {}, axiosInstance),
    ]);

    const deals = [...dealsData?.promotions, ...dealsData?.rewards];

    return {
      ...prerenderData,
      [PrefetchedDataKeys.DEALS]: {
        [shop]: deals || null,
      },
      [PrefetchedDataKeys.PRODUCTS]: products || null,
      metadata: {
        ...prerenderData.metadata,
      },
    };
  } catch (e) {
    console.error("Error fetching deal detail data", e);
    Sentry.setTag("Deal Page Prefetch Error", true);
    Sentry.captureException(e);
    return {
      ...data.prerenderData,
      metadata: {
        ...data.prerenderData.metadata,
      },
    };
  }
};

export const getAllDeals = fetchDealsData;
